import React from 'react'
import glamorous from 'glamorous'
import glamorousIcon from '../../../../lib/glamorous-icon'

import { mediaQueries } from '../../../../transfer/styles'
import CheckMark from '../icons/svg/circledCheckMark.svg'

const { phoneLandscapeMax: mobile } = mediaQueries
const IconContainer = glamorous.div({
  position: 'absolute',
  top: '5.0em',
  left: '-1.18em',
  display: 'flex',
  justifyContent: 'flex-end',
  zIndex: 1,
  [mobile]: {
    top: '5.5em',
  },
})

const IconSVG = glamorousIcon({
  flex: '1 1 auto',
  width: 36,
  height: 36,
  [mobile]: {
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  backgroundColor: 'white',
  paddingTop: '8px',
  paddingBottom: '4px',
  display: 'table',
  '& svg': { height: '36', width: '36', display: 'table-cell' },
})

IconSVG.defaultProps = { svg: CheckMark }

/**
 * Circled Check Mark Icon
 */
class CircledCheckMarkIcon extends React.Component {
  render() {
    return (
      <IconContainer data-testid="checkmark">
        <IconSVG />
      </IconContainer>
    )
  }
}

export default CircledCheckMarkIcon
